module.exports = __WEBPACK_EXTERNAL_MODULE_fec3__;